export default __webpack_public_path__ + "static/MonitorSection_us-0412815d66c717c0488bef41ccfcd1c5.png";